export interface AppliaRoute {
	label: string;
	sublabel?: string;
	description?: string;
	children?: AppliaChildRoute[];
	pathName?: string;
	url?: string;
	pillarNumber?: number;
	disabled?: boolean;
}

export interface AppliaChildRoute extends Omit<AppliaRoute, "children" | "pillarNumber"> {
	url: string;
}

export interface AppliaSiblingRoute {
	label: string;
	url: string;
	pillarNumber?: number;
	pathName?: string;
}

export const routes: AppliaRoute[] = [
	{
		label: "Introduction",
		url: "/introduction",
		pathName: "introduction",
		disabled: true,
		children: [
			{
				url: "/foreword",
				label: "Foreword",
				description: "A word from the APPLiA President and Director General.",
			},
			{
				url: "/about-applia",
				label: "About APPLiA",
				description: "APPLiA - Home Appliance Europe is the leading trade association representing home appliance manufacturers in Europe.",
			},
			{
				url: "/applia-members",
				label: "APPLiA members",
				description: "",
			},
			{
				url: "/global-collaboration",
				label: "Global collaboration",
				description: "",
			},
			{
				url: "/products",
				label: "Products",
				description: "",
			},
			{
				url: "/home-appliance-industry",
				label: "The home appliance industry in Europe",
				description: "",
			},
			{
				url: "/executive-summary",
				label: "Executive summary",
				description: "",
			},
		],
	},
	{
		label: "Advancing sustainable lifestyles",
		sublabel: "Pillar 1",
		url: "/pillar/1",
		pillarNumber: 1,
		children: [
			{
				label: "Production",
				url: "/production",
				description: "The sector has reduced waste, water, and energy consumption during manufacturing, demonstrating that sustainability encompasses both product design and production processes.",
			},
			{
				label: "Use and consumption",
				url: "/use-and-consumption",
				description: "Modern home appliances empower European households to save time, energy, and water — with energy and water consumption per cycle having significantly decreased over the past two decades.",
			},
			{
				label: "Recycling",
				url: "/recycling",
				description: "The home appliance sector shows strong commitment to WEEE collection and recycling across Europe, reintroducing precious raw materials into the economy and reducing reliance on primary resources.",
			},
		],
	},
	{
		label: "Accelerating Europe's growth",
		sublabel: "Pillar 2",
		url: "/pillar/2",
		pillarNumber: 2,
		children: [
			{
				label: "Industrial footprint",
				url: "/industrial-footprint",
				description: "With over 75% of large appliances manufactured within Europe across approximately 130 facilities, the home appliance sector is a major employer and contributor to Europe's industrial base.",
			},
			{
				label: "Innovation",
				url: "/innovation",
				description: "A decade of sustained R&D investment has driven record patent filings at the European Patent Office, though innovation capacity remains concentrated in a small number of member states.",
			},
			{
				label: "Trade",
				url: "/trade",
				description: "An overview of units traded and evolving market dynamics in the European home appliance sector, covering both large and small appliances across domestic and trade flows.",
			},
		],
	},
];
